export const FIND_STATEMENT_TEMPLATE_PLACEHOLDERS_SUCCESS = 'FIND_STATEMENT_TEMPLATE_PLACEHOLDERS_SUCCESS';

export const findStatementTemplatePlaceholdersSuccess = ({ statementTemplates }) => ({
    type: FIND_STATEMENT_TEMPLATE_PLACEHOLDERS_SUCCESS,
    payload: { statementTemplates },
});
